// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleWithIcon_title__Bufp2","iconWrapper":"TitleWithIcon_iconWrapper__qQ5Fx","iconImage":"TitleWithIcon_iconImage__d8T9_","shimmer":"TitleWithIcon_shimmer__GRzam"};